<script setup lang="ts">
import { IconProps } from './IconProps';

withDefaults(defineProps<IconProps>(), {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  background: 'none',
  color: '#788EAE',
  opacity: 1,
});
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :fill="background"
  >
    <path d="M9.836 3H6.166V13H9.836V3ZM11.336 9H13.5C13.8978 9 14.2794 8.84196 14.5607 8.56066C14.842 8.27936 15 7.89782 15 7.5V4.5C15 4.10218 14.842 3.72064 14.5607 3.43934C14.2794 3.15804 13.8978 3 13.5 3H11.336V9ZM2.5 3H4.666V11H2.5C2.10218 11 1.72064 10.842 1.43934 10.5607C1.15804 10.2794 1 9.89782 1 9.5V4.5C1 4.10218 1.15804 3.72064 1.43934 3.43934C1.72064 3.15804 2.10218 3 2.5 3Z" :fill="color" />
  </svg>
</template>
